/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Unit_TotalInputs */

const en_us2_workout_logging_unit_total = /** @type {(inputs: Workout_Logging_Unit_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg`)
};

const pt_br2_workout_logging_unit_total = /** @type {(inputs: Workout_Logging_Unit_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg`)
};

const es_419_workout_logging_unit_total = /** @type {(inputs: Workout_Logging_Unit_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg`)
};

const pt_pt2_workout_logging_unit_total = /** @type {(inputs: Workout_Logging_Unit_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg`)
};

const fr_fr2_workout_logging_unit_total = /** @type {(inputs: Workout_Logging_Unit_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg`)
};

const de_de2_workout_logging_unit_total = /** @type {(inputs: Workout_Logging_Unit_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg`)
};

const it_it2_workout_logging_unit_total = /** @type {(inputs: Workout_Logging_Unit_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kg`)
};

/**
* | output |
* | --- |
* | "kg" |
*
* @param {Workout_Logging_Unit_TotalInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_unit_total = /** @type {((inputs?: Workout_Logging_Unit_TotalInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Unit_TotalInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_unit_total(inputs)
	if (locale === "es-419") return es_419_workout_logging_unit_total(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_unit_total(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_unit_total(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_unit_total(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_unit_total(inputs)
	return en_us2_workout_logging_unit_total(inputs)
});
export { workout_logging_unit_total as "workout-logging.unit_total" }